<template>
  <div class="bmap-component">
    <div
      class="bmap"
      ref="bmap"
    ></div>
  </div>
</template>

<script type="text/ecmascript-6">
/**
 * @desc 百度地图封装组件
 * @author Calvin
 *
 * @prop {Boolean} enableDraggable 启用拖动缩放
 * @prop {Function} initMethod(mapInstance) 初始化方法，提供第一个参数为地图实例
 *
 * @method search(text) 搜索当前城市的POI兴趣点
 * @method setCity(cityName) 设置当前城市
 * @method panTo(point) 展现至当前地点
 * @method setMarkedLocation({point, address})
 * @method resetMap 重置地图状态
 * @method clearMarker 清理全部Marker
 * @method addMarker(point,opt) 添加标记点
 * @method getMarker(id) 获取已标记的包含 marker 的 addeditem
 * @method removeMarker(id) 移除已标记的包含 marker 的 addeditem
 * @method getLocationNshowInfoWindow(point,text,cb) 解析地址并打开InfoWindow
 * @method drawLine(pointArray,opt) 绘制折线
 * @method drawDrivingRoute(start,end,opt) 绘制驾车路径
 * @method setViewportByPoints(points,zoomFactor) 根据传入的点，自动调整视野大小
 *
 * @argument {MarkerObject} userMarker 标记点
 * @argument {address,point} markedLocation 标记地点
 * @argument {BMap.Map} mapInstance 地图实例
 * @argument {Array<{ id, marker, infoWindow, address }>} markerList marker 点集合
 *
 * @event initComplete 地图加载完成
 * @event searchComplete 搜索完成
 * @event mapClick(point) 地图点击事件
 * @event markerListChange(markerList) Marker列表更新事件
 */

const AK_KEY = "d4apEA9WF7vLjkt1fOzD2sWCj5SBPkUa";

export default {
  name: "BMapComponent",
  props: {
    enableDraggable: {
      type: Boolean,
      default: true
    },
    initMethod: {
      type: Function,
      default: () => new Function()
    }
  },
  data() {
    return {
      M_map: null,
      M_lastMarker: null, // 最近标记的Marker
      M_lastLine: null, // 最近标记的折线
      M_location: null,
      M_markerList: [] // Marker集合
    };
  },
  methods: {
    _initMethod() {
      // this._drawBMap();
      this.M_map.clearOverlays();
      this._addMapClickListener();
      if (this.initMethod) {
        this.initMethod(this.mapInstance);
      } else if (this.M_location) {
        this.panTo({ point: this.M_location });
      } else {
        this._setCurrentCityByIp();
      }
    },
    /**
     * @deprecated private method
     */
    _drawBMap() {
      if (this.M_map) return;
      const map = (this.M_map = new BMap.Map(this.$refs.bmap));
      const point = new BMap.Point(116.404, 39.915);
      map.centerAndZoom(point, 14); // 初始化地图，设置中心点坐标和地图级别
      map.disableDoubleClickZoom();
      if (this.enableDraggable) {
        map.enableDragging();
        map.enableScrollWheelZoom();
      } else {
        map.disableDragging();
        map.disableScrollWheelZoom();
      }
      this.$emit("initComplete");
      this.$emit("mapDrive");
    },

    /**
     * @desc 通过IP获取当前城市
     * @deprecated private method
     */
    _setCurrentCityByIp() {
      const map = this.M_map;

      const myCity = new BMap.LocalCity();
      myCity.get(result => {
        const { name, center } = result;
        map.setCenter(name);
        map.panTo(center);
        // console.log("当前定位城市:"+name);
      });
    },

    /**
     * @desc 根据关键字检索特定POI信息服务
     * @param {String} text 检索字段
     * @param {Function} callback 回调函数
     */
    search(text = "", callback = () => null) {
      const map = this.M_map;
      map.clearOverlays();
      const options = {
        // onSearchComplete: (results) => {
        //     if (local.getStatus() == BMAP_STATUS_SUCCESS) {
        //         // 判断状态是否正确
        //         const datas = results.Br.map((result, index) => {
        //             return {
        //                 id: index,
        //                 title: result.title,
        //                 address: result.address,
        //                 point: result.point,
        //                 marker: result.marker,
        //             }
        //         });

        //         console.log({datas});
        //         callback(datas);
        //         this.$emit('searchComplete', datas);
        //     }
        // },
        onMarkersSet: pois => {
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            // 判断状态是否正确
            const datas = pois.map((result, index) => {
              return {
                id: index,
                title: result.title,
                address: result.address,
                point: result.point,
                // marker: result.marker
              };
            });

            // console.log({datas});
            callback(datas);
            this.$emit("searchComplete", datas);
          } else {
            this.$emit("searchComplete", []);
          }
        },
        renderOptions: {
          map,
          autoViewport: true
        }
      };
      var local = new BMap.LocalSearch(map, options);
      local.enableAutoViewport();
      local.search(text);
    },

    /**
     * @desc 设置城市
     * @param {String/Point} cityName 城市名称，默认当前城市
     */
    setCity(cityNameOrPoint) {
      if (!cityNameOrPoint) {
        this._setCurrentCityByIp();
      } else {
        this.M_map.setCenter(cityNameOrPoint);
      }
    },

    /**
     * @desc 将地图的中心点更改为给定的点
     * @param {Object} resultItem 给定的点
     */
    panTo({ point, marker }) {
      this.M_map.panTo(point);
      marker && marker.V.click();
    },

    setMarkedLocation({ point, address }) {
      this.M_location = { point, address };
    },

    _addMapClickListener() {
      this.M_map.onclick = ({ type, target, point, pixel, overlay }) => {
        // console.log({type, target, point, pixel, overlay})
        if (overlay) return;
        this.$emit("mapClick", point);
      };
    },

    /**
     * 清理Marker
     */
    clearMarker() {
      this.M_map.clearOverlays();
      this.M_markerList = [];
      this.$emit("markerListChange", this.M_markerList);
      this.$emit("clearMarkerOver", []);
    },

    resetMarkerPosition(marker, point) {
      marker.setPosition(point);
    },

    /**
     * 解析地址并打开InfoWindow
     * @param {BMap.Point} point
     * @param {String} text
     * @param {String} customAddress 指定地址address以覆盖自动生成的address
     * @param {String} showDeleteButton
     * @param {Funcion} cb
     */
    getLocationNshowInfoWindow(
      id,
      marker,
      text,
      customAddress,
      showDeleteButton,
      cb
    ) {
      this._getLocation(marker.point, _location => {
        this.M_location = _location || {};

        const contentDom = document.createElement("div");
        const h3Dom = document.createElement("h3");
        h3Dom.innerText = text;
        h3Dom.className = "overlay-title";
        const pDom = document.createElement("p");
        pDom.innerHTML = customAddress || _location.address;
        const buttonDom = document.createElement("button");
        buttonDom.innerHTML = "删除";
        buttonDom.className = "overlay-button";
        buttonDom.onclick = () => {
          this.M_map.removeOverlay(marker);
          this.M_markerList = this.M_markerList.filter(item => item.id != id);
          this.$emit("markerListChange", this.M_markerList);
        };

        contentDom.appendChild(h3Dom);
        contentDom.appendChild(pDom);
        showDeleteButton && contentDom.appendChild(buttonDom);

        const infoWindow = new BMap.InfoWindow(contentDom, {
          width: 0,
          height: 0
        });

        cb && cb(infoWindow, _location.address);
      });
    },

    /**
     * @desc 根据传入的点，自动调整视野大小
     * @param {Array<Point>} points
     */
    setViewportByPoints(
      points = this.M_markerList.map(item => item.marker.point),
      zoomFactor = 0
    ) {
      this.M_map.setViewport(
        points.map(item => new BMap.Point(item.lng, item.lat)),
        {
          zoomFactor
        }
      );
    },

    /**
     * @desc 绘制标记点
     * @param {lng: number, lat: number/BMap.Point} point 目标点
     * @param {Object} opt 配置项
     * @param {Boolean} opt.showInfoWindow 是否显示覆盖物 true
     * @param {Boolean} opt.showDeleteButton 是否显示删除按钮 true
     * @param {String} opt.text 覆盖物显示的文字
     * @param {String} opt.address 指定覆盖物显示的地址文字，若指定，则不会自动获取Point地址
     * @param {Object} opt.removeLastMarker 是否移除上次标记的点 true
     * @param {Object} opt.clearOverlays 是否移除所有标记的点 false
     * @param {String} opt.iconUrl 设置marker的icon图标
     * @param {Object} opt.iconOpt 设置marker的icon图标配置项
     */
    addMarker(point, opt = {}) {
      const {
        showInfoWindow = true,
        showDeleteButton = true,
        text = "标记此点",
        address = "",
        id = Math.random()
          .toString(16)
          .substring(2),
        removeLastMarker = true,
        clearOverlays = false,
        autoViewport = true,
        iconUrl = "",
        iconOpt = {}
      } = opt;
      const { lat, lng } = point;
      if (!lat || !lng) return;
      let _point = new BMap.Point(point.lng, point.lat);
      const map = this.M_map;
      if (removeLastMarker) {
        map.removeOverlay(this.M_lastMarker);
        this.M_markerList = this.M_markerList.filter(
          item => item.marker != this.M_lastMarker
        );
        if (this.M_markerList.length > 0)
          this.M_lastMarker = this.M_markerList[this.M_markerList.length - 1];
        else this.M_lastMarker = null;
        this.$emit("markerListChange", this.M_markerList);
      }
      if (clearOverlays) this.clearMarker();
      // console.log(_point);
      const marker = new BMap.Marker(_point); // 创建标注
      if (iconUrl) {
        const { width = 50, height = 50 } = iconOpt;
        const size = new BMap.Size(width, height);
        const icon = new BMap.Icon(iconUrl, size, iconOpt);
        icon.setImageSize(size);
        marker.setIcon(icon);
      }
      marker.setZIndex(999);
      map.addOverlay(marker); // 将标注添加到地图中
      const addedItem = { marker, id, point, address };
      if (!this.getMarker(id)) this.M_markerList.push(addedItem);
      this.$emit("markerListChange", this.M_markerList);
      this._getLocation(point, res => {
        this.$emit("pointOver", res);
      });
      autoViewport && map.panTo(_point);

      this.getLocationNshowInfoWindow(
        id,
        marker,
        text,
        address,
        showDeleteButton,
        (infoWindow, generatedAddress) => {
          addedItem.infoWindow = infoWindow;
          addedItem.address = address || generatedAddress;
          addedItem.marker.onclick = () => {
            addedItem.marker.openInfoWindow(addedItem.infoWindow);
          };
          showInfoWindow && addedItem.marker.openInfoWindow(infoWindow);
        }
      );
      this.M_lastMarker = marker;
      return marker;
    },

    /**
     * @desc 获取地址信息和周边pois
     * @param {BMap.Point} point 目标点
     */
    _getLocation(point, callback) {
      const geoc = new BMap.Geocoder();
      geoc.getLocation(point, rs => {
        // console.log({rs});
        callback && callback(rs);
      });
    },

    /**
     * 获取已标记的包含 marker 的 addeditem
     * @returns {{id, marker, infoWindow}}
     */
    getMarker(id) {
      const { M_markerList } = this;
      let found = -1;
      M_markerList.forEach((item, index) => {
        if (item.id === id) {
          found = index;
        }
      });
      if (found !== -1) return M_markerList[found];
      return null;
    },

    /**
     * 删除已标记的包含 marker 的 addeditem
     */
    removeMarker(id) {
      const markerItem = this.getMarker(id);
      this.M_map.removeOverlay(markerItem.marker);
      this.M_markerList = this.M_markerList.filter(item => item.id !== id);
      if (this.M_markerList.length > 0)
        this.M_lastMarker = this.M_markerList[this.M_markerList.length - 1];
      else this.M_lastMarker = null;

      this.$emit("markerListChange", this.M_markerList);
    },

    resetMap() {
      // this.M_map.reset();
      // console.log('Map reseted');
      this._initMethod();
      // console.log('Map reinit complete');
    },

    /**
     * @desc 绘制驾车路线
     * @param {BMap.Point/Array} start 起点
     * @param {BMap.Point/Array} end 终点
     */
    drawDrivingRoute(points = [], cb = new Function(), opt = {}) {
      // this.M_map.clearOverlays();
      if (points.length < 2) {
        console.warn("Point 数量不能少于2个");
        return;
      }

      const { waypoints = [], showRoute = true } = opt;
      const driving = new BMap.DrivingRoute(this.M_map, {
        renderOptions: {
          map: showRoute ? this.M_map : null,
          autoViewport: true
        },
        onSearchComplete: result => cb(result)
      });

      const start = new BMap.Point(points[0].lng, points[0].lat);
      const end = new BMap.Point(points[1].lng, points[1].lat);
      driving.search(start, end, {
        waypoints
      });
    },

    /**
     * @desc 绘制折线
     * @param {Array<{lng,lat}>/Array<BMap.Point>} pointArray 点集合
     * @param {Object} opt 配置项
     *
     * @param {Boolean} opt.removeLastMarker 是否移除上一个标记点
     * @param {Boolean} opt.clearOverlays 是否清除标记
     */
    drawLine(pointArray = [], opt = {}) {
      const { removeLastMarker = true, clearOverlays = false } = opt;

      const _pointArray = pointArray.map(
        item => new BMap.Point(item.lng, item.lat)
      );
      if (removeLastMarker) this.M_map.removeOverlay(this.M_lastLine);

      const line = (this.M_lastLine = new BMap.Polyline(_pointArray, {
        // strokeColor:
      }));

      if (clearOverlays) this.M_map.clearOverlays();

      this.M_map.addOverlay(line);
    }
  },
  computed: {
    userMarker() {
      return this.M_lastMarker;
    },
    markedLocation() {
      return this.M_location;
    },
    mapInstance() {
      return this.M_map;
    },
    markerList() {
      return this.M_markerList;
    }
  },
  watch: {
    M_lastMarker(newV) {
    //   console.log({ lastMarker: newV });
    }
  },
  mounted() {
    this._drawBMap();
    this._initMethod();
  },
  updated() {

  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.bmap-component {
  width: 100%;
  height: 100%;
  .bmap {
    width: 100%;
    height: 100%;
  }

  .overlay-title {
    font-size: 16px;
    font-weight: bold;
  }
  .overlay-button {
    float: right;
    background: #fa8c16;
    border: none;
    border-radius: 3px;
    color: white;
    padding: 5px 10px;
    margin-top: 5px;
    &:after {
      content: "";
      clear: both;
    }
  }
 
}
</style>
